import './style.css';
import Application from './Application/Application';
// Update document title with current year
document.title = `Varshith Karkera - Portfolio ${new Date().getFullYear()}`;
const app = new Application();
